
export default [
	{
		text: 'Your new profile 🎉',
		text: 'Pop a little information here about who you are, your business and your interests.',
		selector: '#profileHeader',
		position: 'bottom',
	},
	{
		title: 'Edit your profile',
		text: 'Add your website and social links too!',
		selector: '#action-buttons',
		position: 'bottom',
	},
	{
		title: 'About',
		text: 'Tell other users about you. Write your business story here and share the reasons why you want to start your own business.',
		selector: '#aboutPanel',
		position: 'bottom',
	},
	{
		title: 'Interests',
		text: 'What do you want to learn more about? What are you interested in? Highlight the topics below and they’ll appear in your feed.',
		selector: '#interestsPanel',
		position: 'bottom',
	},
	{
		title: 'Emails',
		text: 'We want to make sure you’re not bombarded with emails – tell us how often you’d like to hear from us.',
		selector: '#emailSettings',
		position: 'top',
	}
]



// WEBPACK FOOTER //
// ./src/js/components/Onboarding/steps/profile.js